
import { Component, Emit, Prop, Vue, } from "vue-property-decorator";

@Component({})
export default class NotificationRuleDeleteModal extends Vue {

    @Prop({ type: String, required: true})
    private title: string;

	@Prop({ type: Boolean, default: false }) 
    private showModal: boolean;

	@Emit("cancelDeleteModal")
	private closeModal(): void {
		return;
	}

    @Emit("confirmedDeleteRule")
	private removeRule(): void {
        return;
	}
}
